module.exports = __webpack_public_path__ + "img/hr-rail-signal-metal.25554894.png";